import { useState } from "react";
import { useNavigate } from "react-router-dom";
import { toast } from "sonner";
import { useAuth, apiErr } from "@/context/AuthContext";
import { Store, Lock, Mail, Loader2 } from "lucide-react";

export default function Login() {
  const { login } = useAuth();
  const navigate = useNavigate();
  const [email, setEmail] = useState("khattarudashay03@gmail.com");
  const [password, setPassword] = useState("admin123");
  const [loading, setLoading] = useState(false);

  const submit = async (e) => {
    e.preventDefault();
    setLoading(true);
    try {
      await login(email, password);
      toast.success("Welcome back!");
      navigate("/pos");
    } catch (err) {
      toast.error(apiErr(err));
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="min-h-screen bg-[#0B0F17] flex items-center justify-center p-4">
      <div className="w-full max-w-[400px]">
        <div className="flex flex-col items-center mb-8">
          <div className="w-14 h-14 rounded-2xl bg-[#10B981] flex items-center justify-center mb-4">
            <Store className="w-7 h-7 text-[#06221a]" />
          </div>
          <h1 className="font-head text-2xl font-bold text-white">Restaurant POS</h1>
          <p className="text-sm text-[#6B7280] mt-1">Sign in to start billing</p>
        </div>

        <form
          onSubmit={submit}
          className="bg-[#151D2A] border border-[#23334D] rounded-2xl p-6 space-y-4"
        >
          <div>
            <label className="text-xs font-semibold text-[#9CA3AF] uppercase tracking-wide">Email</label>
            <div className="mt-1.5 relative">
              <Mail className="w-4 h-4 text-[#6B7280] absolute left-3 top-1/2 -translate-y-1/2" />
              <input
                data-testid="login-email"
                type="email"
                value={email}
                onChange={(e) => setEmail(e.target.value)}
                className="w-full bg-[#0B0F17] border border-[#23334D] rounded-lg pl-9 pr-3 py-2.5 text-sm text-white outline-none focus:border-[#10B981]"
                placeholder="you@restaurant.com"
                required
              />
            </div>
          </div>
          <div>
            <label className="text-xs font-semibold text-[#9CA3AF] uppercase tracking-wide">Password</label>
            <div className="mt-1.5 relative">
              <Lock className="w-4 h-4 text-[#6B7280] absolute left-3 top-1/2 -translate-y-1/2" />
              <input
                data-testid="login-password"
                type="password"
                value={password}
                onChange={(e) => setPassword(e.target.value)}
                className="w-full bg-[#0B0F17] border border-[#23334D] rounded-lg pl-9 pr-3 py-2.5 text-sm text-white outline-none focus:border-[#10B981]"
                placeholder="••••••••"
                required
              />
            </div>
          </div>
          <button
            data-testid="login-submit"
            type="submit"
            disabled={loading}
            className="w-full bg-[#10B981] hover:bg-[#059669] text-[#06221a] font-semibold py-2.5 rounded-lg transition-colors flex items-center justify-center gap-2 disabled:opacity-60"
          >
            {loading && <Loader2 className="w-4 h-4 animate-spin" />} Sign In
          </button>
        </form>
      </div>
    </div>
  );
}
